// Select com opção "Criar novo" — usado pra empresa e contato no quick-create.
// Extraído de ComercialPipeline.tsx em 2026-05-23 (frontend wave 3B).
// Sem `onCriar` vira só busca: quem não pode criar não vê a opção (05/10/2026).
import { useState } from 'react';
import { Button, Select } from 'antd';

export function SelectComCriar({ valor, opcoes, placeholder, disabled, onSelecionar, onCriar, labelCriar }: {
  valor: string;
  opcoes: { id: string; label: string }[];
  placeholder: string;
  disabled?: boolean;
  onSelecionar: (id: string) => void;
  onCriar?: (termo: string) => void;
  labelCriar?: string;
}) {
  const [busca, setBusca] = useState('');
  const opt = opcoes.map(o => ({ label: o.label, value: o.id }));
  return (
    <Select
      value={valor || undefined}
      placeholder={placeholder}
      disabled={disabled}
      showSearch
      filterOption={(input, option) =>
        (option?.label as string)?.toLowerCase().includes(input.toLowerCase())}
      onSearch={setBusca}
      onChange={(v) => onSelecionar(v || '')}
      options={opt}
      allowClear
      style={{ width: '100%' }}
      dropdownRender={(menu) => (
        <>
          {menu}
          {onCriar && (
            <div style={{ borderTop: '1px solid #B07500', padding: 8 }}>
              <Button block size="small" type="text"
                onClick={() => onCriar(busca)}
                style={{ background: '#FFF8E8', color: '#B07500', fontWeight: 600, textAlign: 'left' }}>
                ＋ {labelCriar || 'Criar nova empresa'}{busca ? `: "${busca}"` : ''}
              </Button>
            </div>
          )}
        </>
      )}
    />
  );
}
